import PlaylistSearchTileV6 from './PlaylistSearchTileV6'

export default PlaylistSearchTileV6
